/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAlignLeft: {
  name: 'align-left';
  data: string;
} = {
  name: 'align-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 1.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H1Zm0 4a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H1ZM.5 10a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5Zm.5 3.5a.5.5 0 0 0 0 1h14a.5.5 0 0 0 0-1H1Z" fill="currentColor"/></svg>`,
};
